const productHitFields = /* GraphQL */ `
  _meta {
    deliveryId
    deliveryKey
  }
  title
  description
  images {
    name
    endpoint
    defaultHost
    url
  }
  productData {
    categories {
      categories
    }
    productGeos {
      geos
    }
    newArrivalStart
    newArrivalEnd
  }
  shop: shopData {
    price
    calculatedPrice
  }
  ratingSummary {
    id
    count
    average
  }
`;

const recipeHitFields = /* GraphQL */ `
  id
  _meta {
    deliveryId
    deliveryKey
  }
  recipeMetaSection {
    title
    description
    shortDescription
    complexity
  }
  assets {
    name
    endpoint
    defaultHost
    url
  }
  ratingSummary {
    average
    count
  }
`;

const learningHitFields = /* GraphQL */ `
  id
  featuredContent
  title
  _meta {
    deliveryId
    deliveryKey
  }
  headerAsset {
    image {
      name
      endpoint
      defaultHost
    }
  }
`;

/** Unfiltered hit counts for every type, so a single-type query can also feed the tab chips. */
const countFields = /* GraphQL */ `
  CountProduct: searchProductListItems(query: $query, pageSize: 0, page: 0) {
    nbHits
  }
  CountRecipe: listRecipeListItems(query: $query, pageSize: 0, page: 0) {
    nbHits
  }
  CountLearn: searchLearningContent(query: $query, pageSize: 0, page: 0) {
    nbHits
  }
`;

export const searchProducts = /* GraphQL */ `
  query SearchProductListItems(
    $query: String
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $options: SearchableProductOptionsInput
    $pageSize: Int
    $page: Int
  ) {
    searchProductListItems(
      query: $query
      filter: $filter
      sort: $sort
      options: $options
      pageSize: $pageSize
      page: $page
    ) {
      hits {
        ${productHitFields}
      }
      facets {
        facet
        pairs {
          value
          count
        }
      }
      page
      nbHits
      nbPages
    }
    ${countFields}
  }
`;

export const searchRecipes = /* GraphQL */ `
  query ListRecipeListItems(
    $query: String
    $filter: SearchableRecipeFilterInput
    $sort: SearchableRecipeSortInput
    $options: SearchableRecipeOptionsInput
    $pageSize: Int
    $page: Int
  ) {
    listRecipeListItems(
      query: $query
      filter: $filter
      sort: $sort
      options: $options
      pageSize: $pageSize
      page: $page
    ) {
      hits {
        ${recipeHitFields}
      }
      facets {
        facet
        pairs {
          value
          count
        }
      }
      page
      nbHits
      nbPages
    }
    ${countFields}
  }
`;

export const searchLearningContent = /* GraphQL */ `
  query SearchLearningContent(
    $query: String
    $filter: SearchLearningContentFilterInput
    $sort: SearchLearningContentSortInput
    $options: SearchLearningContentOptionsInput
    $pageSize: Int
    $page: Int
  ) {
    searchLearningContent(
      query: $query
      filter: $filter
      sort: $sort
      options: $options
      pageSize: $pageSize
      page: $page
    ) {
      hits {
        ${learningHitFields}
      }
      facets {
        facet
        pairs {
          value
          count
        }
      }
      nbHits
      nbPages
      page
    }
    ${countFields}
  }
`;

export const searchOverview = /* GraphQL */ `
  query SearchOverview($query: String, $pageSize: Int, $page: Int) {
    Product: searchProductListItems(query: $query, pageSize: $pageSize, page: $page) {
      hits {
        ${productHitFields}
      }
      nbHits
    }
    Recipe: listRecipeListItems(query: $query, pageSize: $pageSize, page: $page) {
      hits {
        ${recipeHitFields}
      }
      nbHits
    }
    Learn: searchLearningContent(query: $query, pageSize: $pageSize, page: $page) {
      hits {
        ${learningHitFields}
      }
      nbHits
    }
  }
`;

const searchAll = /* GraphQL */ `
  query searchGlobalTypedContentItems($query: String, $pageSize: Int, $page: Int) {
    searchGlobalTypedContentItems(query: $query, pageSize: $pageSize, page: $page) {
      nbHits
      nbPages
      hits {
        __typename
        ... on RecipeListItem {
          _meta {
            deliveryId
            deliveryKey
          }
          recipeMetaSection {
            title
            description
          }
          assets {
            name
            endpoint
            defaultHost
            url
          }
        }
        ... on Product {
          _meta {
            deliveryId
            deliveryKey
          }
          title
          description
          images {
            name
            endpoint
            defaultHost
            url
          }
          productData {
            productGeos {
              geos
            }
          }
        }
        ... on LearningContent {
          _meta {
            deliveryId
            deliveryKey
          }
          title
          id
          featuredContent
        }
      }
    }
  }
`;

export default searchAll;
